import React from 'react';
import { FsComponentSize } from 'globals/types';
import { CustomTab } from './FsInnerTab.style-elements';
import { getCustomTabStyle } from './FsInnerTab.style';

interface FsInnerTabProps {
  label: string;
  size?: FsComponentSize.M | FsComponentSize.L;
}

const FsInnerTab: React.FC<FsInnerTabProps> = ({
  size = FsComponentSize.M,
  ...props
}) => {
  const customTabStyle = getCustomTabStyle(size);
  return <CustomTab {...props} style={customTabStyle} />;
};

export default FsInnerTab;
